import { router } from "@/router/router";

export interface endpointAware {
  /** The API endpoint string associated with this data type. */
  readonly __endpoint: string;
}

export const str_from_query = (key: string): string | undefined => {
  if (!router.currentRoute.value.query[key]) return undefined;
  return String(router.currentRoute.value.query[key]);
};

// 1. Overload signature when NO default_value is provided (returns number | undefined)
export function number_from_query(key: string): number | undefined;

// 2. Overload signature when a default_value (a number) IS provided (returns number)
export function number_from_query(key: string, default_value: number): number;

// 3. The implementation signature (must be compatible with both overloads)
export function number_from_query(
  key: string,
  default_value?: number,
): number | undefined {
  const queryValue = router.currentRoute.value.query[key];

  if (!queryValue) {
    return default_value;
  }
  return Number(queryValue);
}

type available_query_type = string | number | boolean;

type converter<T extends available_query_type> = (value: string) => T;

export const array_from_query = <T extends available_query_type>(
  key: string,
  c: converter<T>,
): T[] => {
  const query_key = router.currentRoute.value.query[key];
  if (!query_key) return [];
  const query_values = Array.isArray(query_key) ? query_key : [query_key];

  return query_values
    .filter((lqv) => lqv !== null)
    .map((lqv) => {
      return c(lqv as string);
    });
};
